import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import Success from "../components/Success";
import Footer from "../components/Footer";

const PaymentSuccess = () => {
  return (
    <HelmetProvider>
      <LayoutProvider>
        <PageMetaData title="Geo Express | News" />
        <TopNavBar
          position="fixed"
          menuItems={[
            ["მთავარი", "home", "/"],
            ["სერვისები", "services", "/services"],
            ["სიახლეები", "news", "/news"],
            ["კონტაქტი", "contact", "/contact"],
            ["ხშირად დასმული კითხვები", "faqs", "/faq"],
            ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
          ]}
        />
        <Success />
        <Footer />
      </LayoutProvider>
    </HelmetProvider>
  );
};

export default PaymentSuccess;
